import { useGetBalanceSheetQuery } from '@/features/slice/accounting/balance-sheet';

export const useBalanceSheet = () => {
  const { data, isLoading, isError } = useGetBalanceSheetQuery({});
  return { data: data?.data, isLoading, isError };
};
